/**
 * Detail date separator component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Detail date separator component.
 */
const DetailDateSeparator = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${28 * Screen.widthRatio}px;
  margin: 0 ${8 * Screen.widthRatio}px;
`;

export default DetailDateSeparator;
